import { render, staticRenderFns } from "./appealList.vue?vue&type=template&id=90bd8efc&scoped=true&"
import script from "./appealList.vue?vue&type=script&lang=js&"
export * from "./appealList.vue?vue&type=script&lang=js&"
import style0 from "./appealList.vue?vue&type=style&index=0&id=90bd8efc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bd8efc",
  null
  
)

export default component.exports